import React, { useContext, useState } from "react";
import { ImageDisplay, ImageUploader } from "components";
import { AssignmentBuilderContext } from "pages/AppPages/TherapistPages/AssignmentBuilder/useAssignmentBuilderContext";
import { Field } from "types";
import "./ImageField.styles.scss";

interface ImageFieldProps {
  uuid: string | undefined;
  label: string;
  fileUrl: string | undefined;
  showLabelForBuilder?: boolean;
  field: Field;
  validationError?: string;
  fromBuilder?: boolean;
}

const ImageField = ({
  uuid,
  label,
  fileUrl,
  showLabelForBuilder,
  field,
  validationError,
  fromBuilder,
}: ImageFieldProps) => {
  const { editField } = useContext(AssignmentBuilderContext);

  const [currentFileUrl, setCurrentFileUrl] = useState<string | undefined>(
    fileUrl
  );

  return (
    <div key={uuid} className="image-field">
      {showLabelForBuilder && <p className="rich-text-label">{label}</p>}
      {!currentFileUrl ? (
        <ImageUploader
          onSuccess={({ uuid, fileUrl }) => {
            setCurrentFileUrl(fileUrl);
            editField({
              ...field,
              fileId: uuid,
              fileUrl,
            });
          }}
          validationError={validationError}
          fromBuilder={fromBuilder ? true : false}
        />
      ) : (
        <ImageDisplay image={currentFileUrl} />
      )}
    </div>
  );
};

export default ImageField;
